/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellAlarmIcon20Solid = forwardRef('NotificationBellAlarmIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.719 1.992A1 1 0 0 0 3.399.489 9.999 9.999 0 0 0 .004 7.735a1 1 0 0 0 1.999.053 7.999 7.999 0 0 1 2.715-5.796Z" }),
        React.createElement("path", { d: "M15.19.58a1 1 0 0 0 .091 1.412 8 8 0 0 1 2.715 5.796 1 1 0 1 0 2-.053A10 10 0 0 0 16.601.49 1 1 0 0 0 15.19.58Z" }),
        React.createElement("path", { d: "M10 2a6 6 0 0 0-6 6v3.795c0 .032-.01.063-.029.09l-1.746 2.457A1.05 1.05 0 0 0 3.081 16H16.92c.853 0 1.35-.963.856-1.658l-1.746-2.458a.155.155 0 0 1-.029-.09V8a6 6 0 0 0-6-6Z" }),
        React.createElement("path", { d: "M10 19.5A2.5 2.5 0 0 1 7.5 17h5a2.5 2.5 0 0 1-2.5 2.5Z" })));
});
